import { RewardsMetadataSchema } from "@apps/rewards/schemas/RewardsMetadaSchema";
import {
    array,
    assign,
    literal,
    nullable,
    number,
    object,
    string,
    union,
} from "superstruct";

import { REWARDS_SPENDING_RULES_TYPES } from "../constants";
import {
    RewardsSpendingRuleFixedAmountRewardSchema,
    RewardsSpendingRuleFixedPercentageRewardSchema,
    RewardsSpendingRuleFlexibleAmountRewardSchema,
    RewardsSpendingRuleFlexiblePercentageRewardSchema,
    RewardsSpendingRuleFreeShippingRewardSchema,
    RewardsSpendingRuleGiftCardRewardSchema,
    RewardsSpendingRuleProductRewardSchema,
} from "./RewardsSpendingRulesRewardSchema";

//Base spending rules schema
const RewardsSpendingRuleBaseSchema = object({
    ruleId: string(),
    versionId: string(),
    title: string(),
    icon: nullable(string()),
    pointsPrice: number(),
});

//Base points spendable schema
const RewardsSpendingRulePointsSpendableSchema = object({
    minSpendablePoints: number(),
    maxSpendablePoints: number(),
});

//Amount discount schema
const RewardsSpendingRulesAmountDiscountBaseSchema = assign(
    RewardsSpendingRulePointsSpendableSchema,
    object({
        ruleType: literal(REWARDS_SPENDING_RULES_TYPES.amountDiscount),
    })
);

const RewardsSpendingRuleFixedAmountDiscountSchema = object({
    metadata: RewardsMetadataSchema,
    rule: assign(
        RewardsSpendingRuleBaseSchema,
        RewardsSpendingRulesAmountDiscountBaseSchema
    ),
    rewards: array(RewardsSpendingRuleFixedAmountRewardSchema),
});

export const RewardsSpendingRuleFlexibleAmountDiscountSchema = object({
    metadata: RewardsMetadataSchema,
    rule: assign(
        RewardsSpendingRuleBaseSchema,
        RewardsSpendingRulesAmountDiscountBaseSchema
    ),
    rewards: array(RewardsSpendingRuleFlexibleAmountRewardSchema),
});

//Percentage discount schema
const RewardsSpendingRulesPercentageDiscountBaseSchema = assign(
    RewardsSpendingRulePointsSpendableSchema,
    object({
        ruleType: literal(REWARDS_SPENDING_RULES_TYPES.percentageDiscount),
    })
);

const RewardsSpendingRuleFixedPercentageDiscountSchema = object({
    metadata: RewardsMetadataSchema,
    rule: assign(
        RewardsSpendingRuleBaseSchema,
        RewardsSpendingRulesPercentageDiscountBaseSchema
    ),
    rewards: array(RewardsSpendingRuleFixedPercentageRewardSchema),
});

export const RewardsSpendingRuleFlexiblePercentageDiscountSchema = object({
    metadata: RewardsMetadataSchema,
    rule: assign(
        RewardsSpendingRuleBaseSchema,
        RewardsSpendingRulesPercentageDiscountBaseSchema
    ),
    rewards: array(RewardsSpendingRuleFlexiblePercentageRewardSchema),
});

//Gift card schema
const RewardsSpendingRuleGiftCardSchema = object({
    metadata: RewardsMetadataSchema,
    rule: assign(
        RewardsSpendingRuleBaseSchema,
        object({
            ruleType: literal(REWARDS_SPENDING_RULES_TYPES.giftCard),
        })
    ),
    rewards: array(RewardsSpendingRuleGiftCardRewardSchema),
});

//Free shipping schema
const RewardsSpendingRuleFreeShippingSchema = object({
    metadata: RewardsMetadataSchema,
    rule: assign(
        RewardsSpendingRuleBaseSchema,
        object({
            ruleType: literal(REWARDS_SPENDING_RULES_TYPES.freeShipping),
        })
    ),
    rewards: array(RewardsSpendingRuleFreeShippingRewardSchema),
});

//Free product schema
export const RewardsSpendingRuleFreeProductSchema = object({
    metadata: RewardsMetadataSchema,
    rule: assign(
        RewardsSpendingRuleBaseSchema,
        object({
            ruleType: literal(REWARDS_SPENDING_RULES_TYPES.freeProduct),
        })
    ),
    rewards: array(RewardsSpendingRuleProductRewardSchema),
});

export const RewardsSpendingRulesSchema = union([
    RewardsSpendingRuleFixedAmountDiscountSchema,
    RewardsSpendingRuleFlexibleAmountDiscountSchema,
    RewardsSpendingRuleFixedPercentageDiscountSchema,
    RewardsSpendingRuleFlexiblePercentageDiscountSchema,
    RewardsSpendingRuleGiftCardSchema,
    RewardsSpendingRuleFreeShippingSchema,
    RewardsSpendingRuleFreeProductSchema,
]);

export const RewardsSpendingRulesResponseSchema = object({
    items: array(RewardsSpendingRulesSchema),
});
